<style lang="scss" scoped>
.navbar-light .navbar-nav .i-nav-link a {
    color: #616161 !important;
    font-weight: 500;
    padding: 3px 7px !important;
    font-size: 13px !important;
    border-radius: 3px;

    &:hover{
      // background: #e2ffe9;
      color: teal !important;
    }
    
}
.navbar-light .navbar-nav .i-nav-link.active a {
  color: white !important;
  font-weight: 500 !important;
  background: #00897B !important;
}
.navbar-nav{
  margin: 4px 0; 
  
}
.i-nav{
  font-family: 'Manrope';
  background-color: #FFF !important;
  // border-bottom: 1px solid #dee2e6;
  &-wrapper{
    min-height: 44px;
  }
  &-logo{
    color: #16782e !important;
    min-height: 44px;
    & img{
      height:30px;
    }
  }
  &-link{
    margin-right: 7px;
    
    
  }
}
.notif{
  font-size: 12px;
  font-family: 'Manrope','Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 600;
  letter-spacing: .3px;
  
  display: flex;
  justify-content: center;
  
    padding: 0px 50px;
  &__body{
    width:94%;
    display: flex;
    align-items: center;
  }

  &--danger, &--warning{
    background: #ffeeb6;
    color:#7e6000 ;
    border: 1px solid #ffdf76;

  }
}

.countdown{
  background: #fff1c3;
  margin-left: 20px;
  padding: 0 10px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  display: flex;
  align-items: center;
  border-left: 1px solid #ffdd6f;
  border-right: 1px solid #ffdd6f;
  &__item{
    // border-radius: 2px;
    
    // margin: 2px;
    padding: 5px 0 7px 0;
    min-width: 40px;
    // background: #FFAB00;
    color: #6a4700;
    position: relative;

    &:not(:last-child)::after{
      position: absolute;
      right: 0;
      top: 25%;
      content: "";
      height: 25px;
      width: 1px;
      border-right: 1px solid #e3dabd;
    }
  }
  & .time-field{
    text-align: center;
    font-size: 10px;
    font-weight: 400;
  }
  & .time-value{
    text-align: center;
    font-size: 18px;
    line-height: 1;
  }
  
}
.user{
  &__role{
    font-family: 'Manrope';
    font-weight: 500;
    font-size: 13px;
    color: #535353;

    display: flex;
    align-items: center;
    margin-right:10px;
    padding: 0px 10px;
    text-align: right;
    height: 30px;
    border-right: 1px solid rgb(224, 224, 224);
    line-height: 1.2;
  }
}
</style>
<style>
@media screen and (max-width: 600px) {
  .navbar-nav  .dropdown{
      display: block;
    
  }
  .user__role{
    display: none !important;
  }
  .dropdown-toggle{
    padding: 0.25rem .5rem !important;
    margin-top: 20px;
    
  }
  .navbar-nav  .dropdown-menu{
    top:40px;
    /* border-top:1px solid white; */
    box-shadow: none !important;
    border-bottom:none;
    border-top:none;
    font-size:12px;
    
  }
}

.navbar-nav  .dropdown-menu{
    top:40px;
    /* border-top:1px solid white; */
    box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
    border-top:none;
    font-size:12px;
  
}
.navbar-nav  .dropdown-menu .dropdown-item{
    font-size:13px;
    display: flex;
    align-items: center;
    color: #4e4e4e !important;
    padding: 0.25rem 1rem;
    font-weight: 500;
    text-align: left;
}
.navbar-nav  .dropdown-menu .dropdown-header{
    font-size:12px;
    color: #a7a7a7 !important;
    padding: 0.6rem 1rem 0.25rem 1rem;
    font-weight: 500;
}
</style>
<template>
  <div id="navbar-ms">
    <div class="i-nav-wrapper">
      <b-navbar toggleable="lg" class="fixed-top i-nav" :style="$route.path != '/' ? 'border-bottom: 1px solid #dee2e6;' :''">
        <b-container fluid>
          <b-navbar-brand to="/" class="i-nav-logo my-0 py-1">
            <div class="d-flex align-items-center px-2 py-0 my-0 ">
              <div class="mr-1">
                <b-img src="/img/logo-2.svg" fluid alt="Responsive image"></b-img>
              </div>
              <div >
                <div style="font-size:16px;font-weight:700;letter-spacing:1px">INDAH</div>
                <div style="font-size:11px;font-weight:600;margin-top:-6px">Indonesia Data Hub</div>
              </div>
            </div>
          </b-navbar-brand>
          <b-navbar-toggle target="nav-collapse" class="mr-2 button button--action button--outlined">
            <template #default="{ expanded }">
              <b-icon v-if="expanded" icon="x"></b-icon>
              <b-icon v-else icon="list"></b-icon>
            </template>
          </b-navbar-toggle>
          <b-collapse id="nav-collapse" is-nav>
            

            <b-navbar-nav
              v-if="user"
              class="ml-auto"
            >        

              <b-dropdown
                right
                size="sm"
                variant="logout"
                toggle-class="d-flex align-items-center text-primary"
              >
                <template #button-content>
                  {{$store.getters['auth/user'].name}}
                </template>
                <!-- <b-dropdown-item to="/user/profile">
                  <VueFeather type="user" size="14"></VueFeather>&nbsp; Profil
                </b-dropdown-item> -->
                <b-dropdown-item 
                  to="/user/change-password"
                  v-if="!isInternalUser"
                >
                  <VueFeather type="shield" size="14"></VueFeather>&nbsp; Ubah Password
                </b-dropdown-item>
                
                <b-dropdown-group id="dropdown-group-1" header="Pengaturan" v-if="isSuperAdmin || isPembinaData || isWalidata">
                  <b-dropdown-item to="/pengaturan/user" v-if="isSuperAdmin">
                    <VueFeather type="users" size="14" ></VueFeather>&nbsp; User
                  </b-dropdown-item>
                  <b-dropdown-item to="/pengaturan/sdi/organization" v-if="isSuperAdmin || isPembinaData || isWalidata">
                    <VueFeather type="briefcase" size="14"></VueFeather>&nbsp; Organisasi SDI
                  </b-dropdown-item>
                </b-dropdown-group>
                
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item to="/logout"><VueFeather type="power" size="14"></VueFeather>&nbsp; Keluar</b-dropdown-item>
              </b-dropdown>
            </b-navbar-nav>

            <b-navbar-nav v-else class="ml-auto">
              <b-button
                size="sm"
                type="submit"
                to="/login"
                class="button button--primary"
                style="margin:4px 0 ;padding-left:10px;padding-right:15px; border-radius:7px!important;background:#2cad2c !important"
                ><VueFeather type="arrow-right" size="14"></VueFeather>&nbsp;  Masuk</b-button
              >
            </b-navbar-nav>
          </b-collapse>
        </b-container>
        
      </b-navbar>
      
    </div>
  </div>
  
</template>
<script>
import "@/assets/scss/main.scss";
import * as role from "@/views/ms/SdiRole";
import VueFeather from 'vue-feather';
export default {
  components:{
    VueFeather
  },
  name: "Navbar",
  data() {
    return {
      openMegaMenu: false,
      userRoles:[],
      user:null,
    };
  },
  computed:{

    
    isSuperAdmin(){
      return role.isSuperAdmin(this.userRoles);
    },
    isPembinaData(){
      return role.isPembinaData(this.userRoles);
    },
    isWalidata(){
      return role.isWalidata(this.userRoles);
    },
    isInternalUser(){
      return this.user && this.user.email.split('@')[1] == 'bps.go.id'
    }
  },
  
  async mounted() {
    if(this.$store.getters['auth/isAuthenticated']){
      this.getUserInfo(this.$store.getters["auth/user"])
    }
  },
  methods:{
    getUserInfo(user){
      this.user = {
        name : user.name,
        username: user.username,
        email: user.email,
        division: null,
        organization: user.sdiOrganization ? {
          id: user.sdiOrganization.id,
          name: user.sdiOrganization.name,
          address: user.sdiOrganization.details.address,
          province: user.sdiOrganization.details.province,
          city: user.sdiOrganization.details.city,
        } : null,
      },
      this.userRoles = user.role.slice(1,-1).split(", ");
    },
    
  }
}

</script>
